export default __webpack_public_path__ + "static/media/screen6.1dec944e.jpg";